import { setTooltipType } from '../actions'
import { TOOLTIP_STATES, ENABLE_CALENDAR_ID } from '../../constants'

const tooltipsMiddleware = store => next => action => {
    const state = store.getState()
    switch (action.type) {
        case 'TOGGLE_CALENDAR':
            if(state.main.tooltipType !== TOOLTIP_STATES.NONE) {
                if (action.id === ENABLE_CALENDAR_ID) {
                    const calendarEnabled = state.calendars.find(c => c.id === ENABLE_CALENDAR_ID).enabled
                    if(calendarEnabled) {
                        store.dispatch(setTooltipType(TOOLTIP_STATES.SWITCH_ON_OFF))
                    } else {
                        store.dispatch(setTooltipType(TOOLTIP_STATES.MOVE))
                    }
                } else if (
                    state.main.tooltipType === TOOLTIP_STATES.SELECT_CALENDARS &&
                    !state.calendars.filter(c => c.enabled).length
                ) {
                    store.dispatch(setTooltipType(TOOLTIP_STATES.SWITCH_ON_OFF))
                } else if (state.main.tooltipType === 'move' && action.id === ENABLE_CALENDAR_ID) {
                    store.dispatch(setTooltipType(TOOLTIP_STATES.SWITCH_ON_OFF))
                }
            }
            break

        case 'CHANGE_TASK_DATES':
            if (action.actionType === 'move' && state.main.tooltipType === TOOLTIP_STATES.MOVE) {
                store.dispatch(setTooltipType(TOOLTIP_STATES.RESIZE))
            } else if (
                action.actionType === 'resize' &&
                state.main.tooltipType === TOOLTIP_STATES.RESIZE
            ) {
                store.dispatch(setTooltipType(TOOLTIP_STATES.NONE))
            }
            break
        default:
            break
    }

    next(action)
}

export default tooltipsMiddleware
